import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { dealEventLogControllerGetDealEventParticipantsOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { dealEventLogRequestOptions } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventLogUnread.ts';
import type { DealEventFilterOption } from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogFilterOptions.utils.ts';
import { PARTICIPANT_VALUE_SEPARATOR } from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogQuery.utils.ts';

const PARTICIPANT_STALE_TIME_MS = 300_000;

export const useDealEventParticipants = (dealId: string, enabled: boolean) => {
	const query = useQuery({
		...dealEventLogControllerGetDealEventParticipantsOptions(
			dealEventLogRequestOptions(dealId)
		),
		enabled: enabled && !!dealId,
		staleTime: PARTICIPANT_STALE_TIME_MS,
		gcTime: PARTICIPANT_STALE_TIME_MS,
	});

	return useMemo<DealEventFilterOption[]>(
		() =>
			(query.data?.participants ?? []).map(({ investorIds, name }) => ({
				value: investorIds.join(PARTICIPANT_VALUE_SEPARATOR),
				label: name ?? investorIds.join(', '),
			})),
		[query.data]
	);
};
